import { getPortalId } from '../utils/getPortalId';
import SettingsURLMappings from '../constants/SettingsURLMappings';
import getWindow from '../utils/getWindow';
const getSettingsPath = () => {
  const pathParts = /^\/([\w-]+)\/\d+/.exec(getWindow().location.pathname);
  const currentPath = pathParts && pathParts.length >= 1 ? pathParts[1] : null;
  return Object.keys(SettingsURLMappings).reduce((path, type) => {
    if (path !== null) {
      return path;
    }
    const {
      from,
      to
    } = SettingsURLMappings[type];
    const toLink = `${to.replace('**{portalId}**', `${getPortalId()}`)}`;
    if (currentPath === from || from instanceof RegExp && from.test(getWindow().location.pathname)) {
      return toLink;
    }
    return path;
  }, null);
};
export const useSettingsLink = () => {
  const defaultSettingsLink = `/user-preferences/${getPortalId() || ''}`;
  const settingsLinkForCurrentApp = getSettingsPath();
  const link = settingsLinkForCurrentApp || defaultSettingsLink;
  return `${link}?eschref=${encodeURIComponent(window.location.pathname)}`;
};